var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_2766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_2766)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6667H0V20Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667H28V5.33333H0V14.6667Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 9.33333H8.66634V10H7.33301V9.33333Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05934 9.36102C6.04315 9.16668 6.19651 9.00001 6.39153 9.00001H8.27579C8.47081 9.00001 8.62417 9.16668 8.60797 9.36102L8.43669 11.4164C8.3935 11.9347 7.96024 12.3333 7.44015 12.3333H7.22717C6.70708 12.3333 6.27381 11.9347 6.23062 11.4164L6.05934 9.36102Z",
    stroke: "#A41517",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10H8.66667V10.6667H8L7.33333 12L6.66667 10.6667H6V10Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 1.33333,
    height: 4.66667,
    rx: 0.666667,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33301,
    y: 8,
    width: 1.33333,
    height: 4.66667,
    rx: 0.666667,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.73334C6 7.14423 6.47756 6.66667 7.06667 6.66667H7.6C8.1891 6.66667 8.66667 7.14423 8.66667 7.73334C8.66667 7.88061 8.54728 8.00001 8.4 8.00001H6.26667C6.11939 8.00001 6 7.88061 6 7.73334Z",
    fill: "#A41517"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.0ce79591ac782dc925da51c5e90a52e4.svg";
export { ForwardRef as ReactComponent };